module.exports = __webpack_public_path__ + "4c294af6ae6eb957c7026f15761133a7.svg";